import React, { useEffect, useRef, useState } from 'react';
import './SelectList.css';
import { useDetectIfOverflowBottom } from 'hooks/useDetectIfOverflowBottom';
import { CSSTransition } from 'react-transition-group';
import { Arrow, StyledList } from './styles/SelectListStyles';

interface IProps {
  children: any;
  visible: boolean;
  top?: string;
  right?: string;
  bottom?: string;
  left?: string;
  isBelowBottomCallback?: (isBelowBottom: boolean) => void;
  className?: string;
  padding?: string;
}

export const SelectList: React.FC<IProps> = (props) => {
  const { children, visible, top, right, bottom, left, isBelowBottomCallback, className, padding = '14px 13px 12px 11px' } = props;
  const [isBelowBottom, setIsBelowBottom] = useState<boolean>(false);
  const ref = useRef<HTMLDivElement>(null);
  useDetectIfOverflowBottom(ref, visible, (effect: boolean) => {
    isBelowBottomCallback && isBelowBottomCallback(effect);
    setIsBelowBottom(effect);
  });

  return (
    <CSSTransition in={visible} timeout={200}>
      <>
        {visible && (
          <StyledList className={className} ref={ref} style={{ top, right, bottom, left }} padding={padding}>
            <Arrow below={isBelowBottom} />
            {children}
          </StyledList>
        )}
      </>
    </CSSTransition>
  );
};
